import axios from '../../../axios';

export type ServiceResponse = {
  clientName: string;
  clientLicencePlate: string;
  UTTSAvailable: string;
  wantUTTS: string;
  driverName: string;
  driverEmail: string;
  driverPhone: string;
  status: string;
};

export default async function getFleetGPSListRepository(): Promise<ServiceResponse[]> {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/fleet/gpsList`);
  return res.data;
}
